import {
  ShoppingCart, BarChart3, FileText, Users, Globe, Link as LinkIcon, Home,
  Phone, Mail, Instagram, Package, HelpCircle, Settings, Image, Video,
  Calendar, Star, ExternalLink, MessageCircle, Megaphone, Truck, Tag,
} from 'lucide-react';

// Curated icon set for portal menu items (native + external links).
export const PORTAL_ICONS = {
  ShoppingCart, BarChart3, FileText, Users, Globe, Link: LinkIcon, Home,
  Phone, Mail, Instagram, Package, HelpCircle, Settings, Image, Video,
  Calendar, Star, ExternalLink, MessageCircle, Megaphone, Truck, Tag,
};

// Icons offered in the "add external link" picker.
export const LINK_ICON_OPTIONS = [
  'Globe', 'Link', 'ExternalLink', 'Instagram', 'Phone', 'Mail',
  'MessageCircle', 'Megaphone', 'Star', 'Calendar', 'HelpCircle', 'Package',
];

export const getPortalIcon = (name) => PORTAL_ICONS[name] || Globe;
